import MobileResetForm from './container'

export default MobileResetForm 